export default __webpack_public_path__ + "static/media/ENG-PET.44197c73.png";